import { createRouter, createWebHistory } from 'vue-router'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        if (to.hash) return { el: to.hash }
        if (from.path === to.path) return {}
        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path: '/',
            redirect: '/dashboard',
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login.vue'),
            meta: { layout: 'Blank', requiresAuth: false },
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@/views/Dashboard.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/devices',
            name: 'devices',
            component: () => import('@/views/Devices.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/topology',
            name: 'topology',
            component: () => import('@/views/Topology.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/ipam',
            name: 'ipam',
            component: () => import('@/views/IPAM.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/documentation',
            name: 'documentation',
            component: () => import('@/views/Documentation.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/security',
            name: 'security',
            component: () => import('@/views/Security.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/syslog',
            name: 'syslog',
            component: () => import('@/views/Syslog.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/events',
            name: 'events',
            component: () => import('@/views/Events.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/tools',
            name: 'tools',
            component: () => import('@/views/Tools.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/reports/sla',
            name: 'reports-sla',
            component: () => import('@/views/ReportsSLA.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/templates',
            name: 'templates',
            component: () => import('@/views/Templates.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('@/views/Users.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('@/views/Settings.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
        {
            path: '/changelog',
            redirect: { path: '/settings', query: { tab: 'audit' } },
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('@/views/About.vue'),
            meta: { layout: 'Default', requiresAuth: true },
        },
    ],
})

router.beforeEach((to) => {
    const appStore = useAppStore()
    const loggedIn = appStore.isLoggedIn()

    if (loggedIn && to.name === 'login') return { name: 'dashboard' }
    if (to.meta.requiresAuth !== false && !loggedIn) {
        appStore.setLogout()
        return { name: 'login', query: to.fullPath !== '/' ? { redirect: to.fullPath } : {} }
    }
})

export default router
